module.exports = __webpack_public_path__ + "static/media/contact_tagline.f5a4514d.svg";